import React, { useState, useRef, useMemo, useEffect } from "react";
import Header from "../../../components/Header";
import NavigationComponent from "../../../components/NavigationComponent";
import "./cmsBlog.css";
import JoditEditor from "jodit-react";
import axios from "axios";
import { toast } from "react-toastify";
import { getBlogs } from "../../../adminApi/blog";
import BlogModalDelete from "./BlogModalDelete";

function CmsBlog() {
  const token = localStorage.getItem("access_token");
  const editor = useRef(null);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [blogDatas, setBlogData] = useState([]);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [addBlogActive, setAddBlogActive] = useState(false);
  const [content, setContent] = useState("");
  const [formData, setFormData] = useState({});
  const [images, setImages] = useState([]);
  const [blogAudio, setBlogAudio] = useState(null);
  const [blogVideoLink, setBlogVideoLink] = useState();
  const [blogTitle, setBlogTitle] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const [selectedVoice, setSelectedVoice] = useState();
  const [blogDescription, setBlogDescription] = useState();
  const [prevBlogTitle, setPrevBlogTitle] = useState();
  const [prevBlogVideoLink, setPrevBlogVideoLink] = useState();
  const [prevBlogImage, setPrevBlogImage] = useState();
  const [prevAudio, setPrevAudio] = useState();
  const [deleteBlog, setDeleteBlog] = useState();
  let postBlogImageData = {};
  const hanldeBlogImage = async (e) => {
    setSelectedImage(e.target.value);
    e.preventDefault();
    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles?.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();

        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });
        // Start loading the file
        reader.readAsDataURL(file);
        // Wait for the FileReader to finish loading
        await loadPromise;
        const convertedFile = {
          image: reader.result,
        };
        const convertedFileName = {
          name: file.name,
        };
        setImages([convertedFile]);
        setFormData({ ...formData, file: convertedFileName });
        postBlogImageData = {
          image: convertedFile.image,
        };
      }
    } catch (error) {
      return error;
    }
  };
  const handleVoiceImage = (e) => {
    setSelectedVoice(e.target.value);
    setBlogAudio(e.target.files[0]);
  };
  const blogHandler = async () => {
    if (
      blogTitle?.length === undefined &&
      content?.length === 0 &&
      selectedImage === undefined
    ) {
      toast.error("Image,Title,Description is required fields.");
      return;
    }
    if (blogTitle?.length === undefined) {
      toast.error("Blog title can't be empty.");
      return;
    }
    if (content?.length === 0) {
      toast.error("Blog Description can't be empty.");
      return;
    }
    if (selectedImage === undefined) {
      toast.error("You need to provide the Image for the blog.");
      return;
    }
    //performing the API call here
    const token = localStorage.getItem("access_token");
    try {
      const adminId = localStorage.getItem("adminId");
      const body = new FormData();

      body.append("image", images[0].image);
      body.append("voice", blogAudio);
      body.append("title", blogTitle);
      body.append("content", content);
      body.append("video", blogVideoLink);
      body.append("fk_admin_user", adminId);
      body.append("is_active_blog", 1);
      const formDataObject = {};
      body.forEach((value, key) => {
        formDataObject[key] = value;
      });

      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + `/admin/blog_create`,
        formDataObject,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status == 201) {
        toast.success("Blog created successfully");
        setAddBlogActive(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const accordionHandler = async (index, id) => {
    setActiveAccordion(index === activeAccordion ? null : index);
    const response = await getBlogs(token, 0, 100000);
    setSelectedImage("");
    setSelectedVoice("");
    setBlogDescription(response?.data?.[index]?.content);
    setPrevBlogTitle(response?.data?.[index]?.title);
    setPrevBlogVideoLink(
      response?.data?.[index]?.video === undefined
        ? "No link added"
        : response?.data?.[index]?.video
    );
    setPrevBlogImage(response?.data?.[index]?.image);
    setPrevAudio(response?.data?.[index]?.voice);
  };

  useEffect(() => {
    fetchBlogData();
  }, [showDeleteModal]);

  const fetchBlogData = async () => {
    const response = await getBlogs(token, 0, 100000);
    setBlogData(response?.data);
  };

  const hanldePrevBlogImage = async (e) => {
    e.preventDefault();
    setSelectedImage(e.target.value);
    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles?.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();

        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });
        // Start loading the file
        reader.readAsDataURL(file);
        // Wait for the FileReader to finish loading
        await loadPromise;
        const convertedFile = {
          image: reader.result,
        };
        const convertedFileName = {
          name: file.name,
        };
        setImages([convertedFile]);

        setFormData({ ...formData, file: convertedFileName });
        postBlogImageData = {
          image: convertedFile.image,
        };
      }
    } catch (error) {
      return error;
    }
  };

  const handlePrevVoiceImage = async (e) => {
    setSelectedVoice(e.target.value);
    setBlogAudio(e.target.files[0]);
  };

  const updateBlogHandler = async (blog) => {
    try {
      const token = localStorage.getItem("access_token");
      const body = new FormData();
      if (images[0]?.image) {
        body.append("image", images[0]?.image);
      }
      if (blogAudio) {
        body.append("voice", blogAudio ? blogAudio : prevAudio);
      }
      body.append("title", prevBlogTitle);
      body.append("content", blogDescription);
      body.append("video", prevBlogVideoLink);
      body.append("id", blog?.id);
      // body.append('is_active_blog',1);
      const formDataObject = {};
      body.forEach((value, key) => {
        formDataObject[key] = value;
      });

      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + `/admin/blog_update`,
        formDataObject,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.status === 200) {
        toast.success("Blog updated successfully.");
        await fetchBlogData();
      }
    } catch (error) {}
  };

  const deleteBlogHandler = async (blog) => {
    setDeleteModal(true);
    setDeleteBlog(blog);
  };
  return (
    <>
      {/* <div dangerouslySetInnerHTML={{ __html: content }} /> */}
      <div className="container--component">
        <div className="container--grid">
          <NavigationComponent />
          <div className="Adminpage">
            <Header title="Blog" subTitle="(Manage Blog)" />

            <div className="addBlogBtn_container">
              <button
                className="add-blog-btn"
                onClick={() => {
                  setAddBlogActive(!addBlogActive);
                  setActiveAccordion(null);
                }}
              >
                {addBlogActive ? "Close" : "Add Blog"}
              </button>
            </div>

            {/* =================================Add blog section starts====================================== */}
            {addBlogActive && (
              <div class="accordion__card__body" style={{ display: "block" }}>
                <h3 class="title">
                  Note: Compress back after completion of activity
                </h3>
                <div class="commonList">
                  <div class="commonList__row">
                    <div class="commonList__row__col">
                      <h4 class="label">Blog Image:</h4>
                      <div class="cardbox">
                        <div class="browseBox">
                          <div class="browseFile">
                            <div class="browseFile__icon">
                              <svg
                                width="33"
                                height="33"
                                viewBox="0 0 33 33"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                              >
                                <rect
                                  x="0.180664"
                                  width="32.53"
                                  height="32.53"
                                  fill="url(#pattern0)"
                                />
                                <defs>
                                  <pattern
                                    id="pattern0"
                                    patternContentUnits="objectBoundingBox"
                                    width="1"
                                    height="1"
                                  >
                                    <image xlinkHref="data:image/png;base64,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" />
                                  </pattern>
                                </defs>
                              </svg>
                            </div>
                            <h4 class="browseFile__text">
                              Drag files to upload
                            </h4>
                            <p class="browseFile__ortext">or</p>
                            <input
                              class="hiddenInput"
                              id="BrowseFiles"
                              type="file"
                              onChange={(e) => hanldeBlogImage(e)}
                            />
                            <label for="BrowseFiles" class="browseBtn">
                              Browse Files
                            </label>
                            <span>{selectedImage?.split("\\").pop()}</span>
                            <div class="browseFileData">
                              <p class="browseFileData__text">
                                Max File Size: <strong>10 MB</strong>
                              </p>
                              <p class="browseFileData__text">
                                Supported file type:{" "}
                                <strong>JPG,PNG,SVG</strong>
                              </p>
                            </div>
                          </div>
                          {/* <div class="adminbutton__group">
                              <button class="adminbtn adminbtn-transparent">
                                Cancel
                              </button>
                              <button class="adminbtn adminbtn-primary"
                              >
                                Save
                              </button>
                            </div> */}
                        </div>
                      </div>
                    </div>

                    <div class="commonList__row__col">
                      <h4 class="label"> Blog Voice:</h4>
                      <div class="cardbox">
                        <div class="browseBox">
                          <div class="browseFile">
                            <div class="browseFile__icon">
                              <svg
                                width="33"
                                height="33"
                                viewBox="0 0 33 33"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                              >
                                <rect
                                  x="0.180664"
                                  width="32.53"
                                  height="32.53"
                                  fill="url(#pattern0)"
                                />
                                <defs>
                                  <pattern
                                    id="pattern0"
                                    patternContentUnits="objectBoundingBox"
                                    width="1"
                                    height="1"
                                  >
                                    <use
                                      xlinkHref="#image0_0_11529"
                                      transform="scale(0.01)"
                                    />
                                  </pattern>
                                  <image
                                    id="image0_0_11529"
                                    width="100"
                                    height="100"
                                    xlinkHref="data:image/png;base64,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"
                                  />
                                </defs>
                              </svg>
                            </div>
                            <h4 class="browseFile__text">
                              Drag files to upload
                            </h4>
                            <p class="browseFile__ortext">or</p>
                            <input
                              class="hiddenInput"
                              id="BrowseFiles2"
                              type="file"
                              onChange={(e) => handleVoiceImage(e)}
                            />
                            <label for="BrowseFiles2" class="browseBtn">
                              Browse Files
                            </label>
                            <span>{selectedVoice?.split("\\").pop()}</span>
                            <div class="browseFileData">
                              <p class="browseFileData__text">
                                Max File Size: <strong>20 MB</strong>
                              </p>
                              <p class="browseFileData__text">
                                Supported file type: <strong>mp3,wav</strong>
                              </p>
                            </div>
                          </div>
                          {/* <div class="adminbutton__group">
                              <button class="adminbtn adminbtn-transparent">
                                Cancel
                              </button>
                              <button class="adminbtn adminbtn-primary"
                              >
                                Save
                              </button>
                            </div> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="commonList__row">
                    <h4 class="label">Blog Video Link</h4>
                    <div class="cardbox">
                      <div class="adminform__group">
                        <input
                          type="text"
                          className="cmsBlog-title-input"
                          placeholder="provide the link here! "
                          onChange={(e) => setBlogVideoLink(e.target.value)}
                        />
                      </div>
                      {/* <div class="adminbutton__group">
                          <button class="admibtn admibtn-transparent">
                            Cancel
                          </button>
                          <button class="admibtn admibtn-primary"
                          //  onClick={descriptionHandler}
                          >
                            Save
                          </button>
                        </div> */}
                    </div>
                  </div>

                  <div class="commonList__row">
                    <h4 class="label">Blog Title</h4>
                    <div class="cardbox">
                      <div class="adminform__group">
                        <input
                          type="text"
                          className="cmsBlog-title-input"
                          placeholder="provide the title here! "
                          onChange={(e) => setBlogTitle(e.target.value)}
                        />
                      </div>
                      {/* <div class="adminbutton__group">
                          <button class="admibtn admibtn-transparent">
                            Cancel
                          </button>
                          <button class="admibtn admibtn-primary"
                          //  onClick={descriptionHandler}
                          >
                            Save
                          </button>
                        </div> */}
                    </div>
                  </div>
                  <div class="commonList__row">
                    <h4 class="label">Blog Description:</h4>
                    <div class="cardbox">
                      <div class="adminform__group">
                        {/* <Editor editorState={editorState} onChange={setEditorState} /> */}
                        <JoditEditor
                          ref={editor}
                          value={content}
                          onChange={(newContent) => {
                            setContent(newContent);
                          }}
                        />
                      </div>
                      <div class="adminbutton__group">
                        {/* <button class="admibtn admibtn-blueOutline">
                          Cancel
                        </button> */}
                        <button
                          class="admibtn admibtn-primary"
                          onClick={blogHandler}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/*=========================== Add blog section ends===============================*/}

            {/* =================Update the Blog section========================== */}

            {blogDatas?.map((blog, index) => (
              <div
                className={`accordion__card ${
                  activeAccordion === index ? "active" : ""
                }`}
                style={{ cursor: "pointer" }}
                key={blog?.id}
              >
                <div
                  class="accordion__card__header"
                  onClick={() => accordionHandler(index, blog?.id)}
                >
                  <h2 class="title">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.4615 3.7712C7.72183 3.51085 7.72183 3.08874 7.4615 2.82839L5.57588 0.942771C5.53707 0.903964 5.49647 0.868044 5.45433 0.835024C5.00181 0.480349 4.37288 0.459313 3.89943 0.771917C3.82549 0.820731 3.75535 0.877684 3.69026 0.942771L1.80464 2.82839C1.54429 3.08874 1.54429 3.51085 1.80464 3.7712C2.06499 4.03155 2.4871 4.03155 2.74745 3.7712L3.99992 2.51872V12C3.99992 12.3682 4.2984 12.6666 4.66659 12.6666C5.03478 12.6666 5.33325 12.3682 5.33325 12V2.58576L6.51869 3.7712C6.77903 4.03154 7.20117 4.03154 7.4615 3.7712Z"
                        fill="white"
                      />
                      <path
                        d="M8.47162 12.2288C8.21128 12.4892 8.21128 12.9112 8.47162 13.1716L10.3572 15.0572C10.4224 15.1223 10.4925 15.1793 10.5664 15.2281C11.084 15.5698 11.7872 15.5128 12.2429 15.0572L14.1285 13.1716C14.3888 12.9112 14.3888 12.4892 14.1285 12.2288C13.8682 11.9684 13.446 11.9684 13.1857 12.2288L12.0002 13.4142V4.00004C12.0002 3.63185 11.7018 3.33337 11.3336 3.33337C10.9654 3.33337 10.6669 3.63185 10.6669 4.00004V13.4812L9.41442 12.2288C9.15408 11.9684 8.73195 11.9684 8.47162 12.2288Z"
                        fill="white"
                      />
                    </svg>
                    {blog?.title}
                  </h2>
                  <div class="actions">
                    <button class="actions__btn accordionToggleBtn">
                      <svg
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.707131 7.28933C0.316631 6.89883 0.316631 6.26563 0.707131 5.87513L5.59933 0.987686C6.38053 0.207286 7.64633 0.207595 8.42713 0.988375L13.3175 5.87873C13.708 6.26923 13.708 6.90243 13.3175 7.29293C12.9269 7.68353 12.2938 7.68353 11.9032 7.29293L7.71763 3.10733C7.32703 2.71683 6.69393 2.71683 6.30343 3.10733L2.12133 7.28933C1.73083 7.67983 1.09763 7.67983 0.707131 7.28933Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                    <button class="actions__btn">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H9M15 5H17C18.1046 5 19 5.89543 19 7V9"
                          stroke="white"
                          strokeWidth="2.33333"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M14.9015 20.3343L12.7148 20.7716L13.1521 18.585C13.1909 18.3914 13.286 18.2136 13.4256 18.074L17.4995 14L19.4995 12L21.4864 13.9869L19.4864 15.9869L15.4125 20.0608C15.2729 20.2004 15.0951 20.2956 14.9015 20.3343Z"
                          stroke="white"
                          strokeWidth="2.33333"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                          stroke="white"
                          strokeWidth="2.33333"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="accordion__card__body">
                  <h3 class="title">
                    Note: Compress back after completion of activity
                  </h3>
                  <div class="commonList">
                    <div class="commonList__row">
                      <div class="commonList__row__col">
                        <h4 class="label">Blog Image:</h4>
                        <div class="cardbox">
                          <div class="browseBox">
                            <div class="browseFile">
                              <div class="browseFile__icon">
                                <svg
                                  width="33"
                                  height="33"
                                  viewBox="0 0 33 33"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                >
                                  <rect
                                    x="0.180664"
                                    width="32.53"
                                    height="32.53"
                                    fill="url(#pattern0)"
                                  />
                                  <defs>
                                    <pattern
                                      id="pattern0"
                                      patternContentUnits="objectBoundingBox"
                                      width="1"
                                      height="1"
                                    >
                                      <image xlinkHref="data:image/png;base64,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" />
                                    </pattern>
                                  </defs>
                                </svg>
                              </div>
                              <h4 class="browseFile__text">
                                Drag files to upload
                              </h4>
                              <p class="browseFile__ortext">or</p>
                              <input
                                class="hiddenInput"
                                id="BrowseFiles"
                                type="file"
                                onChange={(e) => hanldePrevBlogImage(e)}
                              />
                              <label for="BrowseFiles" class="browseBtn">
                                Browse Files
                              </label>
                              <h6>{selectedImage?.split("\\").pop()}</h6>
                              <div class="browseFileData">
                                <p class="browseFileData__text">
                                  Max File Size: <strong>10 MB</strong>
                                </p>
                                <p class="browseFileData__text">
                                  Supported file type:{" "}
                                  <strong>JPG,PNG,SVG</strong>
                                </p>
                              </div>

                              <div>
                                <img src={blog?.image} alt="blog_image" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="commonList__row__col">
                        <h4 class="label"> Blog Voice:</h4>
                        <div class="cardbox">
                          <div class="browseBox">
                            <div class="browseFile">
                              <div class="browseFile__icon">
                                <svg
                                  width="33"
                                  height="33"
                                  viewBox="0 0 33 33"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                >
                                  <rect
                                    x="0.180664"
                                    width="32.53"
                                    height="32.53"
                                    fill="url(#pattern0)"
                                  />
                                  <defs>
                                    <pattern
                                      id="pattern0"
                                      patternContentUnits="objectBoundingBox"
                                      width="1"
                                      height="1"
                                    >
                                      <use
                                        xlinkHref="#image0_0_11529"
                                        transform="scale(0.01)"
                                      />
                                    </pattern>
                                    <image
                                      id="image0_0_11529"
                                      width="100"
                                      height="100"
                                      xlinkHref="data:image/png;base64,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"
                                    />
                                  </defs>
                                </svg>
                              </div>
                              <h4 class="browseFile__text">
                                Drag files to upload
                              </h4>
                              <p class="browseFile__ortext">or</p>
                              <input
                                class="hiddenInput"
                                id="BrowseFiles2"
                                type="file"
                                onChange={(e) => handlePrevVoiceImage(e)}
                              />
                              <label for="BrowseFiles2" class="browseBtn">
                                Browse Files
                              </label>
                              <h6>{selectedVoice?.split("\\").pop()}</h6>
                              <div class="browseFileData">
                                <p class="browseFileData__text">
                                  Max File Size: <strong>20 MB</strong>
                                </p>
                                <p class="browseFileData__text">
                                  Supported file type: <strong>mp3,wav</strong>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="commonList__row">
                      <h4 class="label">Blog Video Link</h4>
                      <div class="cardbox">
                        <div class="adminform__group">
                          <input
                            type="text"
                            className="cmsBlog-title-input"
                            placeholder="provide the link here! "
                            value={prevBlogVideoLink}
                            onChange={(e) =>
                              setPrevBlogVideoLink(e.target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div class="commonList__row">
                      <h4 class="label">Blog Title</h4>
                      <div class="cardbox">
                        <div class="adminform__group">
                          <input
                            type="text"
                            className="cmsBlog-title-input"
                            placeholder="provide the title here! "
                            value={prevBlogTitle}
                            onChange={(e) => setPrevBlogTitle(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div class="commonList__row">
                      <h4 class="label">Blog Description:</h4>
                      <div class="cardbox">
                        <div class="adminform__group">
                          <JoditEditor
                            ref={editor}
                            value={blogDescription}
                            onChange={(newContent) =>
                              setBlogDescription(newContent)
                            }
                            // config={{
                            //   events: {
                            //     beforePaste: handleBeforePaste,
                            //   },
                            // }}
                          />
                        </div>
                        <div class="adminbutton__group">
                          {/* <button class="admibtn admibtn-blueOutline">
                            Cancel
                          </button> */}
                          <button
                            class="admibtn admibtn-primary"
                            onClick={() => updateBlogHandler(blog)}
                          >
                            Save
                          </button>

                          <button
                            className="delete-btn admibtn admibtn-primary"
                            onClick={() => deleteBlogHandler(blog)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* ======================================Update the blog section ends=============================== */}

            {showDeleteModal && (
              <BlogModalDelete
                setDeleteModal={setDeleteModal}
                deleteBlog={deleteBlog}
                setActiveAccordion={setActiveAccordion}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default CmsBlog;
